// Currency, status, formatting helpers
export function formatPrice(price, currency = "TRY") {
  if (price == null || isNaN(Number(price))) return "—";
  const v = Number(price);
  const map = { TRY: "₺", USD: "$", EUR: "€" };
  const symbol = map[currency] || "";
  return symbol + " " + v.toLocaleString("tr-TR", { maximumFractionDigits: 0 });
}

export const STATUS_STYLES = {
  "Satışta": { label: "Satışta", color: "#10B981", bg: "rgba(16,185,129,0.12)", text: "#047857" },
  "Rezerve": { label: "Rezerve", color: "#3B82F6", bg: "rgba(59,130,246,0.12)", text: "#1D4ED8" },
  "Kapora Alındı": { label: "Kapora", color: "#F59E0B", bg: "rgba(245,158,11,0.14)", text: "#B45309" },
  "Satıldı": { label: "Satıldı", color: "#334155", bg: "#E2E8F0", text: "#334155" },
  "Güncellemede": { label: "Güncellemede", color: "#8B5CF6", bg: "rgba(139,92,246,0.13)", text: "#6D28D9" },
  "Teslim Edildi": { label: "Teslim", color: "#0F172A", bg: "rgba(15,23,42,0.1)", text: "#0F172A" },
  "Pasif": { label: "Pasif", color: "#CBD5E1", bg: "#F1F5F9", text: "#64748B" },
};

export const STATUS_LEGEND = ["Satışta", "Rezerve", "Kapora Alındı", "Satıldı", "Güncellemede", "Pasif"];

export function statusStyle(status) {
  return STATUS_STYLES[status] || STATUS_STYLES.Pasif;
}

export function statusChipStyle(status) {
  const s = statusStyle(status);
  return { background: s.bg, color: s.text };
}

export function statusClass(status) {
  if (!status) return "status-Pasif";
  if (status === "Kapora Alındı") return "status-Kapora";
  if (status === "Teslim Edildi") return "status-Teslim";
  return "status-" + status.replace(/\s+/g, "");
}

export function unitCellClass(status) {
  if (!status) return "unit-Pasif";
  if (status === "Kapora Alındı") return "unit-Kapora";
  if (status === "Teslim Edildi") return "unit-Teslim";
  return "unit-" + status.replace(/\s+/g, "");
}

export const UNIT_STATUSES = ["Satışta", "Rezerve", "Kapora Alındı", "Satıldı", "Güncellemede", "Teslim Edildi", "Pasif"];
export const ROOM_TYPES = ["Stüdyo", "1+1", "2+1", "3+1", "4+1", "5+1", "Dubleks", "Tripleks", "Ticari", "Diğer"];
export const UNIT_TYPES = ["Daire", "Dükkan", "Ofis", "Villa", "Dubleks", "Bahçe Katı Daire", "Çatı Dubleksi", "Ticari Alan", "Depo", "Otopark", "Diğer"];
export const ASPECTS = ["Kuzey", "Güney", "Doğu", "Batı", "Kuzeydoğu", "Kuzeybatı", "Güneydoğu", "Güneybatı"];
export const VIEWS = ["Şehir", "Bahçe", "Cadde", "Havuz", "Deniz", "Orman", "Vadi", "İç Avlu", "Arka Cephe", "Ön Cephe", "Manzarasız"];
export const FLOOR_POSITIONS = ["Giriş", "Ara Kat", "Üst Kat", "Bahçe Katı", "Çatı Katı", "Kod Altı", "Kod Üstü"];
export const CURRENCIES = ["TRY", "USD", "EUR"];
export const CUSTOMER_SOURCES = ["Web sitesi", "Telefon", "Satış ofisi", "Instagram", "Facebook", "Google reklam", "Sahibinden / ilan platformu", "Tabela / şantiye önü", "Referans", "Mevcut müşteri", "Eski proje müşterisi", "WhatsApp", "Diğer"];
export const CUSTOMER_STATUSES = ["Yeni", "Arandı", "Ulaşılamadı", "Randevu Alındı", "Satış Ofisine Geldi", "Teklif Verildi", "Kapora Bekleniyor", "Kapora Alındı", "Satışa Döndü", "İlgisiz", "İptal"];
export const PROJECT_TYPES = ["Konut", "Villa", "Rezidans", "Ticari", "Karma Proje"];
export const SALE_TYPES = ["Topraktan Satış", "Devam Eden Proje", "Teslime Hazır", "Tamamlanmış Proje", "Karma"];
export const PROJECT_STATUSES = ["Ön Satışta", "Devam Ediyor", "Tamamlandı", "Satışa Kapalı", "Pasif"];
export const PAYMENT_TYPES = ["Peşin", "Nakit / Havale", "Vadeli / Taksitli", "Araç Takaslı", "Arsa Takaslı", "Karma", "Diğer"];
export const NOTE_CHANNELS = ["Telefon", "WhatsApp", "Yüz yüze", "Satış ofisi", "E-posta", "Online toplantı", "Diğer"];
export const INTEREST_STATUSES = ["İlgileniyor", "Plan Gösterildi", "Fiyat Verildi", "Randevu Verildi", "Vazgeçti", "Rezervasyona Döndü", "Kapora Alındı", "Satışa Döndü"];
export const ROLE_LABELS = { admin: "Firma Sahibi / Admin", manager: "Satış Müdürü", agent: "Satış Temsilcisi", demo_viewer: "İnceleme Hesabı", super_admin: "Platform Yöneticisi" };
